import { CommonModule } from '@angular/common';
import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  input,
  output,
  computed,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { Transaction } from '../../../home/models/transaction.model';
import { AddRemoveControlComponent } from '../../../shared/components/add-remove-control/add-remove-control.component';
import { LatestIssuanceComponent } from '../../../shared/components/latest-issuance/latest-issuance.component';
import { TrafficLightComponent } from '../../../shared/components/traffic-light/traffic-light.component';
import { FastTooltipDirective } from '../../../shared/directives/fast-tooltip.directive';
import { ItemCartSourceDirective } from '../../../shared/directives/item-cart-source.directive';
import { BoldSpanPipe } from '../../../shared/pipes/bold-span.pipe';
import { PrefixPipe } from '../../../shared/pipes/prefix.pipe';
import { SafeHtmlPipe } from '../../../shared/pipes/safe-html.pipe';
import { UnifiedSearchResult } from '../../models/search.model';

@Component({
  imports: [
    CommonModule,
    FastTooltipDirective,
    BoldSpanPipe,
    SafeHtmlPipe,
    AddRemoveControlComponent,
    LatestIssuanceComponent,
    TrafficLightComponent,
    MatIconModule,
    PrefixPipe,
    ItemCartSourceDirective,
  ],
  selector: 'semeris-transaction-result-item',
  templateUrl: './transaction-result-item.component.html',
  styleUrls: ['./transaction-result-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionResultItemComponent {
  public readonly item = input<UnifiedSearchResult<Transaction>>(undefined);
  public readonly term = input<string>(undefined);

  public readonly close = output();
  public readonly add = output<string>();
  public readonly remove = output<string>();

  public readonly transaction = computed<Transaction>(() => this.item()?.item);
  public readonly description = computed<string>(() => {
    const transaction = this.transaction();
    return `${transaction.managerDisplayName} - ${transaction.transactionDisplayShortName}`;
  });

  public onAdd(item: UnifiedSearchResult<Transaction>) {
    this.add.emit(item?.item?.transactionId);
  }

  public onRemove(item: UnifiedSearchResult<Transaction>) {
    this.remove.emit(item?.item?.transactionId);
  }

  public onClose() {
    this.close.emit();
  }
}
